import React from 'react';
import { CoveyAnalystChart, CoveyAnalystPerformance } from './CoveyAnalystChart';
import { CoveyAnalystPortfolio, CoveyAnalystTable } from './CoveyAnalystTable';

export interface CoveyAnalystMetricsProps {
  data?: CoveyMetricsData;
  variant?: CoveyMetricsDisplayVariant;
}

export type CoveyMetricsDisplayVariant = 'full' | 'chart' | 'table';
export interface CoveyMetricsData {
  performance: CoveyAnalystPerformance[];
  buy_sell: CoveyAnalystBuySell[];
  portfolio: CoveyAnalystPortfolio[];
  community: number;
}

interface CoveyAnalystBuySell {
  symbol: string;
  percent_traded_30_day: number;
}

export const CoveyAnalystMetrics: React.FC<CoveyAnalystMetricsProps> = ({ data, variant = 'full' }) => {
  const longPortfolio = data?.portfolio?.filter(item => item.percent === Math.abs(item.percent));
  const shortPortfolio = data?.portfolio
    ?.filter(item => item.percent !== Math.abs(item.percent))
    .sort((a, b) => a.percent - b.percent);

  const buySellData =
    data && Array.isArray(data?.buy_sell)
      ? data.buy_sell.map(item => {
          const percent = item.percent_traded_30_day;

          return {
            percent,
            symbol: item.symbol,
          };
        })
      : undefined;

  const mostBought = buySellData?.filter(item => item.percent === Math.abs(item.percent));
  const mostSold = buySellData
    ?.filter(item => item.percent !== Math.abs(item.percent))
    .sort((a, b) => a.percent - b.percent);

  return (
    <div className="covey-analyst-metrics w-full">
      {(variant === 'full' || variant === 'chart') && data?.performance && (
        <CoveyAnalystChart data={data?.performance} />
      )}
      {(variant === 'full' || variant === 'table') && (
        <div className="covey-analyst-tables flex flex-wrap gap-4 mt-0.5 sm:grid grid-cols-2 lg:grid-cols-4 grid-rows-auto sm:gap-2">
          <CoveyAnalystTable data={longPortfolio} title="Combined Long Portfolio of Top 10% Analysts" />
          <CoveyAnalystTable data={shortPortfolio} title="Combined Short Portfolio of Top 10% Analysts" />
          <CoveyAnalystTable data={mostBought} title="Most Bought (30 Days) of Top 10% Analysts" />
          <CoveyAnalystTable data={mostSold} title="Most Sold (30 Days) of Top 10% Analysts" />
        </div>
      )}
    </div>
  );
};
